import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3033';
const base = `${apiUrl}/api/palettes`;

export const listPalettes = () => axios.get(base).then((r) => r.data.palettes);
export const getPalette = (id) => axios.get(`${base}/${id}`).then((r) => r.data.palette);
export const createPalette = (payload) => axios.post(base, payload).then((r) => r.data.palette);
export const updatePalette = (id, payload) => axios.put(`${base}/${id}`, payload).then((r) => r.data.palette);
export const deletePalette = (id) => axios.delete(`${base}/${id}`).then((r) => r.data);
